<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" style="padding-top:0;margin-top:0">
        <el-col>
          <el-form-item label="副仓：" v-if="subWarehouseList && subWarehouseList.length > 1">
            <el-select size="medium" v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择" clearable multiple collapse-tags
              style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户：" v-if="currentOrderFlag == 0">
            <el-select size="medium" filterable v-model="searchForm.TC_COMPANY" placeholder="请选择" clearable @change="queryPROJECT">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：" v-if="currentOrderFlag == 0">
            <el-select size="medium" filterable v-model="searchForm.PROJECT" @change="__querydkList()" placeholder="请选择" clearable multiple
              collapse-tags>
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
                <span style="float: left">{{ item.PROJECT_NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户：" v-else>
            <el-select size="medium" v-model="searchForm.SUPPLIER" filterable placeholder="请选择" clearable @change="handleSearch">
              <el-option v-for="item in supplierList" :key="item.value" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
                <span style="float: left">{{ item.AB_NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口：" v-if="currentOrderFlag == 0">
            <el-select size="medium" filterable v-model="searchForm.dkName" placeholder="请选择档口" style="width: 100%" clearable>
              <el-option v-for="item in dkList" :key="item.value" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID：">
            <el-input size="medium" v-model="searchForm.ORDER_ID"></el-input>
          </el-form-item>
          <el-form-item label="选择日期：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单类型：" v-if="currentOrderFlag == 0">
            <el-select size="medium" filterable v-model="searchForm.ADDED_ORDER" placeholder="请选择" clearable>
              <el-option v-for="item in addedOrderTypeList" :key="item.value" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配送类型：" v-if="currentOrderFlag == 0">
            <el-select multiple filterable v-model="searchForm.配送类型" placeholder="请选择配送类型" clearable>
              <el-option v-for="item in 团餐客户配送类型列表" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单备注：" v-if="currentOrderFlag == 0">
            <el-input v-model="searchForm.ORDER_LIST_COMMENT" placeholder="请输入订单备注" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button id="search" size="medium" type="primary" @click="handleSearch()" :loading="loadSearch">
              筛选
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain @click="exportTotalOrder" v-if="fun_dic[100040204]">
              导出订单
            </el-button>
            <el-button size="medium" type="primary" plain @click="exportSMPKindOrder" v-if="currentOrderFlag == 0 && fun_dic[100040205]">
              导出订单（自有分类）
            </el-button>
            <el-button size="medium" type="primary" plain @click="openExportPDF" v-if="currentOrderFlag == 0 && fun_dic[100040206]">
              导出PDF
            </el-button>
            <el-button size="medium" @click="importHistoricalDocuments" v-show="fun_dic[100040202]">导入历史单据</el-button>
            <el-button size="medium" @click="exportFinanceOrder" v-if="currentOrderFlag == 0">导入第四种订单</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button size="medium" @click="requestInvoice" style="margin-bottom: 20px;" v-show="fun_dic[100040203]">
          申请发票
        </el-button>
      </el-col>
    </el-row>
    <!-- 导入历史单据 -->
    <el-dialog :visible.sync="importOrderDialog" title="导入订单" width="400px" center>
      <el-form ref="importForm" v-model="importForm">
        <el-upload :data="$uploadParams" class="upload-demo" ref="upload" action="/uploadFile" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="this.importForm.importName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadTemplate" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="importOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleImportOrder">确认</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-tabs type="border-card" @tab-click="handleTabClick" v-model="activeName">
        <el-tab-pane label="团餐客户订单">
          <el-col :span="24">
            <el-table :data="newOrderListData" ref="newOrderListData" border stripe show-summary :summary-method="getSummaries" style="width: 100%"
              @selection-change="handleTCSelectionChange" :row-key="getTCRowKeys">
              <el-table-column type="selection" width="40" :reserve-selection="true"></el-table-column>
              <el-table-column prop="ORDER_ID" width="80" label="订单ID"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="95"></el-table-column>
              <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口" min-width="90"></el-table-column>
              <el-table-column prop="REAL_TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column label="客户类型">
                <template slot-scope="scope">
                  <el-tag>{{ showOrderType[scope.row.TC_STATUS - 1] }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="REAL_TOTAL_WEIGHT" label="总重（KG）" min-width="100"></el-table-column>
              <el-table-column prop="ORDER_LIST_COMMENT" label="订单备注" min-width="100"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" min-width="90"></el-table-column>
              <el-table-column prop="ADDED_ORDER" label="订单类型" min-width="85"></el-table-column>
              <el-table-column fixed="right" label="操作" width="260">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">导出订单
                  </el-button>
                  <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质
                  </el-button>
                  <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告
                  </el-button>
                  <el-button type="text" size="small" v-if="scope.row.ADDED_ORDER == '第四种订单'" @click="openReleationShop(scope.row)">采购单据</el-button>
                  <el-button type="text" size="small" @click="openDateDia(scope.row)" v-if="scope.row.TC_STATUS == 2">修改日期</el-button>
                  <el-button type="text" size="small" @click="修改客户(scope.row)" v-if="Number(scope.row.TC_STATUS) == 2 && fun_dic[100040207]">
                    修改客户
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="供应商客户订单">
          <el-col :span="24">
            <el-table :data="supplierCusHistoryData" ref="supplierCusHistoryData" border stripe show-summary :summary-method="getSupplierSummaries"
              style="width: 100%" @selection-change="handleGYSSelectionChange" :row-key="getGYSRowKeys">
              <el-table-column type="selection" width="40" :reserve-selection="true"></el-table-column>
              <el-table-column type="index" width="50" min-width="30" label="序号"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="195"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="95"></el-table-column>
              <el-table-column prop="SUPPLIER_CLIENT_NAME" label="客户" min-width="90"></el-table-column>
              <el-table-column prop="TOTAL_GYS_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column prop="REAL_TOTAL_WEIGHT" label="总重（KG）" min-width="100"></el-table-column>
              <el-table-column fixed="right" label="操作" width="260">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="supplierCusdetail(scope.row)">查看
                  </el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">导出订单
                  </el-button>
                  <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质
                  </el-button>
                  <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleSupplierChange" :current-page.sync="currentSupplierPage" :page-size="supplierPageSize"
              layout="total,prev, pager, next, jumper" :total="supplierTotalCount">
            </el-pagination>
          </el-col>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-dialog :visible.sync="importFinanceOrderDialog" title="导入第四种订单" width="400px" center>
      <el-form ref="importFinanceOrder" v-model="importFinanceOrder">
        <el-upload :data="$uploadParams" class="upload-demo" ref="upload" action="/uploadFile" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="this.importFinanceOrder.file" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadFinanceTmp" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="importFinanceOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleImportFinanceOrder">确认</el-button>
      </div>
    </el-dialog>
    <!-- 修改日期模态框 -->
    <el-dialog title="修改送货日期" center :visible.sync="DateVisible" width="400px" @close="closeDate">
      <p style="color: red">此功能请在和客户约定好之后进行使用，慎用！</p>
      <el-form v-model="editDateForm" :ref="editDateForm">
        <el-form-item label="选择目标日期：">
          <el-date-picker v-model="editDateForm.CHSEND_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <el-button @click="closeDate">取 消</el-button>
        <el-button @click="submitModifyDate">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出PDF模态框 -->
    <el-dialog title="导出PDF" center :visible.sync="pdfFormVisible" width="500px">
      <el-form :model="pdfForm" ref="pdfForm">
        <el-form-item label="日期范围：">
          <el-date-picker v-model="pdfForm.SEND_DATE" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="是否带价格：">
          <el-radio-group v-model="priceRadio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否导出实发数量：">
          <el-radio-group v-model="sendCountRadio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否带实收：">
          <el-radio-group v-model="realCountRadio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="订单格式：">
          <el-radio-group v-model="docType">
            <el-radio :label="1">全联单</el-radio>
            <el-radio :label="0">半联单</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfFormVisible = false">取 消</el-button>
        <el-button @click="submitExportPdf">确 定</el-button>
      </div>
    </el-dialog>
    <VInvoiceForm v-if="invoiceFormVisible" :invoiceFormVisible="invoiceFormVisible" :requestData="requestData" :source="'request'"
      @closeDialog="getDialogStatus"></VInvoiceForm>
    <el-dialog :visible.sync="修改客户模态框" title="修改客户" width="500px" center>
      <el-form size="medium" :model="修改客户表单" ref="修改客户表单" :inline="true">
        <el-form-item label="客户：" label-width='120px'>
          <el-select @change="(e) => { 修改客户拉取项目点(e) }" style="width: 300px" filterable v-model="修改客户表单.TC_ID" placeholder="请选择客户">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：" label-width='120px'>
          <el-select @change="(e) => { 修改项目点拉取档口(e) }" style="width: 300px" filterable v-model="修改客户表单.PROJECT_ID" placeholder="请选择项目点">
            <el-option v-for="item in 修改客户用项目点列表" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口：" label-width='120px'>
          <el-select style="width: 300px" filterable v-model="修改客户表单.DK_ID" placeholder="请选择档口">
            <el-option v-for="item in 修改客户用档口列表" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="修改客户模态框 = false">取 消</el-button>
        <el-button size="small" @click="确认修改客户()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  historyDataFun, importHistoryDocuments, outHistoryFun, outHistoryAllFun, exportCheckFun,
  outSelfKindOrder, supplierCusHistoryFun, exportConfirmOrderFun, exportFinanceOrderFun, exportPdfOrder,
  selectTCFun, getHaveSupplyRelationshipProjectList,
} from 'api/sellOrder';
import { getSellerBuyerInvoiceInfo, getInvoiceMaxFee } from 'api/invoice';
import { supplierCusFun } from 'api/customerManage';
import { getActionFun } from 'api/login';
import VInvoiceForm from '../financeCenter/invoiceForm';
import http from '@/assets/common/http';
import date from '@/assets/common/date';
import orderMixin from '@/assets/common/mixins/orderMixin.js';

export default {
  components: {
    VInvoiceForm,
  },
  mixins: [orderMixin],
  data() {
    return {

      showOrderType: ['系统下单', '自录订单', '系统下单+自录订单'],
      // loadOut: false,
      // loading: false,
      loadSearch: false,
      shopName: '清美',
      managername: '老张',
      companys: [],
      points: [
        {
          PROJECT_ID: '',
          PROJECT_NAME: '',
        },
      ],
      dkList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      PAGE_ID: '1000402', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        100040202: 0, 100040203: 0, 100040204: 0, 100040205: 0, 100040206: 0, 100040207: 0,
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      newOrderListData: JSON.parse(sessionStorage.getItem('tableData')) ? JSON.parse(sessionStorage.getItem('tableData')) : [],
      searchForm: JSON.parse(sessionStorage.getItem('searchForm')) ? JSON.parse(sessionStorage.getItem('searchForm')) : { DAY_INTERVAL: [date(new Date() - 30 * 24 * 60 * 60 * 1000, '%F'), date(new Date(), '%F')] },
      index: 0,
      pageTitle: '历史订单列表',
      团餐客户配送类型列表: this.$util.团餐客户配送类型列表,
      currentSupplierPage: 1,
      supplierPageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      supplierTotalCount: 0,
      supplierCusHistoryData: [],
      supplierList: [],
      currentOrderFlag: 0,
      importOrderDialog: false,
      file_name: '',
      fileList: [],
      importForm: {
        importName: 'tmp',
      },
      importFinanceOrderDialog: false,
      importFinanceOrder: {
        file: 'tmp',
      },
      DateVisible: false,
      editDateForm: {},
      pdfFormVisible: false,
      pdfForm: {},
      priceRadio: 1,
      sendCountRadio: 1,
      realCountRadio: 0,
      docType: 1,
      activeName: '0',
      TCArray: [],
      GYSArray: [],
      invoiceFormVisible: false,
      requestData: {},
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      修改客户模态框: false,
      修改客户表单: {},
      修改客户用项目点列表: [],
      修改客户用档口列表: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    if (this.HISTORY_SEARCH_DATA_CONDITION.CONDITION) {
      this.searchForm = this.HISTORY_SEARCH_DATA_CONDITION.CONDITION;
      this.currentPage = this.HISTORY_SEARCH_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    // 获取供应商
    this.queryTitle();
    // 控制价格更新按钮
    this.queryBeforeFun();
    // 获取供应商客户列表
    this.querySupplierList();
    // 团餐客户订单
    this.queryNewOrderListData();
    // 团餐客户订单
    // this.querysupplierCusHistoryData()
    this.queryCustomer();
  },
  computed: {
    HISTORY_SEARCH_DATA_CONDITION() {
      return this.$store.state.HISTORY_SEARCH_DATA_CONDITION;
    },
  },
  methods: {
    确认修改客户() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 103,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.修改客户表单.ORDER_ID,
        TC_ID: this.修改客户表单.TC_ID,
        PROJECT_ID: this.修改客户表单.PROJECT_ID,
        STALL_ID: this.修改客户表单.DK_ID,
      };
      http.post(params).then((res) => {
        this.queryNewOrderListData();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.修改客户表单 = {};
        this.修改客户模态框 = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改项目点拉取档口(e) {
      if (!this.修改客户表单.PROJECT_ID) {
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: e,
      };
      http.post(params).then((result) => {
        this.修改客户用档口列表 = result;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    修改客户拉取项目点(e) {
      if (!this.修改客户表单.TC_ID) {
        return false;
      }
      this.修改客户表单.PROJECT_ID = '';
      const params = {
        TC_ID: e,
      };
      getHaveSupplyRelationshipProjectList(params).then((result) => {
        if (result[0]) {
          this.修改客户用项目点列表 = result;
        } else {
          this.修改客户用项目点列表 = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改客户(row) {
      this.修改客户模态框 = true;
      this.修改客户表单.ORDER_ID = row.ORDER_ID;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (
          index === 1 || index === 2 || index === 3 || index === 4 || index === 5 || index === 6 || index === 9 || index === 10) {
          return;
        }
        const values = data.map((item) => Number(item[column.property])); // 总价列的数组
        if (!values.every((value) => Number.isNaN(value))) {
          // 判断当前列有无NaN  ，有则直接这一列合计为 '--'
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr); // 防止是字符串累加
            if (!Number.isNaN(value)) {
              return prev + value;
            }
            return prev;
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    getSupplierSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (
          index === 1 || index === 2 || index === 3 || index === 4) {
          return;
        }
        const values = data.map((item) => Number(item[column.property])); // 总价列的数组
        if (!values.every((value) => Number.isNaN(value))) {
          // 判断当前列有无NaN  ，有则直接这一列合计为 '--'
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr); // 防止是字符串累加
            if (!Number.isNaN(value)) {
              return prev + value;
            }
            return prev;
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // 控制价格更新按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // ------------------------------------查看
    detail(row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
      sessionStorage.setItem('tableData', JSON.stringify(this.newOrderListData));
      sessionStorage.setItem('searchForm', JSON.stringify(this.searchForm));
      sessionStorage.setItem('NEED_TCNAME', row.TC_NAME);
      this.$router.push({ path: '/historyOrderDetail/detail' });
    },
    orderContract(row) {
      if (this.currentOrderFlag == 1) {
        this.$router.push({ name: 'orderContract', params: { id: row.ID } });
      } else {
        this.$router.push({ name: 'orderContract', params: { id: row.ORDER_ID } });
      }
      sessionStorage.setItem('pageTitle', this.pageTitle);
    },
    // -------------------------------------进入页面拉取数据
    queryNewOrderListData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length != 0) {
        params.PROJECT_ID = JSON.parse(JSON.stringify(this.searchForm.PROJECT));
      }
      if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) {
        params.ADDED_ORDER = this.searchForm.ADDED_ORDER;
      }
      if (this.searchForm.dkName) {
        params.DK_ID = this.searchForm.dkName;
      }
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.ORDER_ID) {
        if (!/^\d+$/.test(this.searchForm.ORDER_ID)) {
          this.$message.show({ text: '请输入一个正确的订单ID', type: 'warning' });
          return;
        }
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.searchForm.ORDER_LIST_COMMENT) {
        params.ORDER_LIST_COMMENT = this.searchForm.ORDER_LIST_COMMENT;
      }
      if (this.searchForm.配送类型 && this.searchForm.配送类型.length) {
        params.DETAIL_TYPE = this.searchForm.配送类型;
      }
      this.loadSearch = true;
      historyDataFun(params).then((result) => {
        if (result[0]) {
          this.newOrderListData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_HISTORY_SEARCH_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.newOrderListData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loadSearch = false;
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------------------获取项目点信息列表
    queryTitle() {
      getHaveSupplyRelationshipProjectList().then((result) => {
        this.points = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------------------------下拉框获取档口名称
    __querydkList() {
      if (this.searchForm.PROJECT.length === 0) {
        this.dkList = [];
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length != 0) {
        params.PROJECTS_ID = this.searchForm.PROJECT;
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // ---------------------------------------------导出单条订单
    output(row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
          };
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
            params.ORDER_ID = row.ID;
          } else {
            params.ORDER_ID = row.ORDER_ID;
          }
          outHistoryFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // -------------------------------------------------提交导出所有订单按钮
    exportTotalOrder() {
      if (!(this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2)) {
        this.$message.show({ text: '请选择导出日期范围', type: 'warning' });
        return false;
      }
      const params = {
        START_DATE: this.searchForm.DAY_INTERVAL[0],
        END_DATE: this.searchForm.DAY_INTERVAL[1],
      };
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length != 0) {
        params.PROJECT_ID = JSON.parse(JSON.stringify(this.searchForm.PROJECT));
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.currentOrderFlag == 1) {
        // 供应商客户
        params.STATUS = 7;
        params.IS_SUPPLIER_CLIENT = 1;
        params.THIRD_INFO = 1;
        if (this.searchForm.SUPPLIER) {
          params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
        }
        exportConfirmOrderFun(params).then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        // 团餐客户
        if (this.searchForm.TC_COMPANY) {
          params.TC_ID = this.searchForm.TC_COMPANY;
        }
        outHistoryAllFun(params).then((result) => {
          if (result[0]) {
            if (result[0].FILE_PATH) {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            }
            if (result[0].TASK_CREATED_SUCCESSFULLY) {
              this.$util.getUnreadInformation(this);
              this.$confirm(this.$util.appointmentMessage, '温馨提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
              }).then(() => {
                this.$router.push({ name: 'appointmentHandling' });
              }).catch(() => {
                this.$message.show({ type: 'info', text: '取消操作' });
              });
            }
          } else {
            this.$message.show({ text: '无相关信息', type: 'warning' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    // 自有分类导出
    exportSMPKindOrder() {
      if (!(this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2)) {
        this.$message.show({ text: '请选择导出日期范围', type: 'warning' });
        return false;
      }
      const params = {
        START_DATE: this.searchForm.DAY_INTERVAL[0],
        END_DATE: this.searchForm.DAY_INTERVAL[1],
      };
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length != 0) {
        params.PROJECT_ID = JSON.parse(JSON.stringify(this.searchForm.PROJECT));
      }
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      outSelfKindOrder(params).then((result) => {
        if (result[0]) {
          if (result[0].FILE_PATH) {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          }
          if (result[0].TASK_CREATED_SUCCESSFULLY) {
            this.$util.getUnreadInformation(this);
            this.$confirm(this.$util.appointmentMessage, '温馨提示', {
              confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
            }).then(() => {
              this.$router.push({ name: 'appointmentHandling' });
            }).catch(() => {
              this.$message.show({ type: 'info', text: '取消操作' });
            });
          }
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryNewOrderListData();
    },
    // ---------------------------------------------------点击筛选按钮触发
    handleSearch() {
      this.currentPage = 1;
      this.currentSupplierPage = 1;
      if (this.currentOrderFlag == 0) {
        this.queryNewOrderListData();
      } else if (this.currentOrderFlag == 1) {
        this.querysupplierCusHistoryData();
      }
      this.$refs.newOrderListData.clearSelection();
      this.$refs.supplierCusHistoryData.clearSelection();
    },
    queryPROJECT() {
      this.searchForm.PROJECT = [];
      const paramsProject = {
        TC_ID: this.searchForm.TC_COMPANY,
      };
      if (this.searchForm.TC_COMPANY) {
        getHaveSupplyRelationshipProjectList(paramsProject).then((result) => {
          if (result[0]) {
            this.points = result;
          } else {
            this.points = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    exportCheck(row) {
      const params = {
        ORDER_ID: row.ORDER_ID,
      };
      if (this.currentOrderFlag == 1) {
        params.ORDER_ID = row.ID;
        params.IS_SUPPLIER_CLIENT = 1;
      }
      exportCheckFun(params)
        .then((result) => {
          this.$message.show({ text: '导出成功', type: 'success' });
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 团餐公司客户数据列表渲染
    querysupplierCusHistoryData() {
      const params = {
        PAGESIZE: this.supplierPageSize,
        PAGEINDEX: this.currentSupplierPage - 1,
        IS_SUPPLIER_CLIENT: 1,
      };
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.SUPPLIER) {
        params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      supplierCusHistoryFun(params).then((result) => {
        if (result[0]) {
          this.supplierCusHistoryData = result[0].list;
          this.supplierTotalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_HISTORY_SEARCH_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.supplierCusHistoryData = [];
          this.supplierTotalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 团餐公司客户订单的分页切换按钮
    handleSupplierChange(e) {
      this.currentSupplierPage = e;
      this.querysupplierCusHistoryData();
    },
    querySupplierList() {
      const params = {};
      supplierCusFun(params).then((res) => {
        if (res.length !== 0) {
          this.supplierList = res[0].list;
        } else {
          this.supplierList = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    handleTabClick(tab, event) {
      sessionStorage.setItem('salesHistoryOrderListActiveName', this.activeName);
      this.currentOrderFlag = Number(tab.index);
      if (this.currentOrderFlag == 0) {
        this.queryNewOrderListData();
      } else if (this.currentOrderFlag == 1) {
        this.querysupplierCusHistoryData();
      }
    },
    // 供应商用户列表查看详情
    supplierCusdetail(row) {
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('TEM_ISSUPPLIER', 1);
      this.$router.push({ path: '/supplierCusHisOrderDetail/detail' });
    },
    // 导入历史单据按钮
    importHistoricalDocuments() {
      this.importOrderDialog = true;
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    // 导入历史单据
    handleImportOrder() {
      if (this.file_name) {
        const params = {
          FILE_NAME: this.file_name,
        };
        importHistoryDocuments(params)
          .then((result) => {
            if (result[0].FILE_PATH == '') {
              this.$message.show({ text: '导入成功', type: 'success' });
              this.file_name = '';
              this.$refs.upload.clearFiles();
              this.importOrderDialog = false;
              this.queryNewOrderListData();
            } else {
              this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'warning' });
              this.file_name = '';
              this.$refs.upload.clearFiles();
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
          });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
    // 下载导入历史订单模板
    downLoadTemplate() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/puchandsale.xlsx';
    },
    exportFinanceOrder() {
      this.importFinanceOrderDialog = true;
    },
    downLoadFinanceTmp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/exportType4OrderTemp.xls';
    },
    handleImportFinanceOrder() {
      if (this.file_name) {
        const params = {
          FILE_NAME: this.file_name,
        };
        exportFinanceOrderFun(params)
          .then((result) => {
            if (result[0].FILE_PATH == '') {
              this.$message.show({ text: '导入成功', type: 'success' });
              this.file_name = '';
              this.$refs.upload.clearFiles();
              this.importOrderDialog = false;
              this.queryNewOrderListData();
            } else {
              this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'warning' });
              this.file_name = '';
              this.$refs.upload.clearFiles();
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
          });
      } else {
        this.$message.show({ text: '请点击上传文件', type: 'warning' });
      }
    },
    openReleationShop(row) {
      sessionStorage.setItem('sellOrderID', row.ORDER_ID);
      this.$router.push({ name: 's_HistoryOrderList' });
    },
    // 打开修改日期模态框
    openDateDia(row) {
      this.ORDER_ID_DATE = row.ORDER_ID;
      this.DateVisible = true;
    },
    // 关闭修改日期模态框
    closeDate() {
      this.DateVisible = false;
      this.editDateForm = {};
    },
    // 修改日期
    submitModifyDate() {
      // 关账限制
      if (this.$util.isOrderClosed(this.editDateForm.CHSEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法修改为此日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 45,
        ORDER_ID: Number(this.ORDER_ID_DATE),
      };
      if (this.editDateForm.CHSEND_DAY) {
        params.CHSEND_DAY = this.editDateForm.CHSEND_DAY;
      } else {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.queryNewOrderListData();
        this.DateVisible = false;
        this.editDateForm = {};
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -------------------------------------选择客户
    queryCustomer() {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          this.companys = [...new Set(result[0].company.map((item) => JSON.stringify(item)))].map((item) => JSON.parse(item));
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openExportPDF() {
      this.pdfFormVisible = true;
    },
    submitExportPdf() {
      const params = {
        PRICE_FLAG: this.priceRadio,
        SEND_COUNT_FLAG: this.sendCountRadio,
        iRCOUNTFlag: this.realCountRadio,
        HALF_PAGE_FLAG: this.docType,
        STATUS: 7,
      };
      if (!this.pdfForm.SEND_DATE) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      if (this.pdfForm.SEND_DATE) {
        params.START_DAY = this.pdfForm.SEND_DATE[0];
        params.END_DAY = this.pdfForm.SEND_DATE[1];
      }
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
        params.PROJECTS_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      exportPdfOrder(params).then((result) => {
        this.$message.show({ text: '导出PDF成功', type: 'success' });
        this.pdfFormVisible = false;
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleTCSelectionChange(val) {
      this.TCArray = val;
    },
    handleGYSSelectionChange(val) {
      this.GYSArray = val;
    },
    getTCRowKeys(row) {
      return row.ORDER_ID;
    },
    getGYSRowKeys(row) {
      return row.ID;
    },
    requestInvoice() {
      if (!Number(this.activeName)) {
        if (!this.searchForm.TC_COMPANY) {
          this.$message.show({ text: '请先筛选客户', type: 'warning' });
          return false;
        }
        if (!this.TCArray.length) {
          this.$message.show({ text: '请先选择要申请发票的订单', type: 'warning' });
          return false;
        }
      } else {
        if (!this.searchForm.SUPPLIER) {
          this.$message.show({ text: '请先筛选客户', type: 'warning' });
          return false;
        }
        if (!this.GYSArray.length) {
          this.$message.show({ text: '请先选择要申请发票的订单', type: 'warning' });
          return false;
        }
      }
      const params = {
        IS_SUPPLIER_CLIENT: Number(this.activeName),
      };
      if (!Number(this.activeName)) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      } else {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER;
      }
      getSellerBuyerInvoiceInfo(params).then(async (res) => {
        this.requestData = {
          ...res,
          tcID: this.searchForm.TC_COMPANY,
          supplierID: this.searchForm.SUPPLIER,
          orderList: Number(this.activeName) ? this.GYSArray.map((item) => item.ID) : this.TCArray.map((item) => item.ORDER_ID),
          isSupplierClient: Number(this.activeName),
        };
        await getInvoiceMaxFee({ IS_SUPPLIER_CLIENT: Number(this.activeName), ORDER_LIST: this.requestData.orderList }).then((res1) => {
          this.requestData.maxFee = Number(res1[0].TOTAL_MAX_FEE);
          this.invoiceFormVisible = true;
        });
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
    },
    // 获取来自发票模态框的状态响应值
    getDialogStatus(res) {
      this.invoiceFormVisible = false;
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/HistoryOrderList.vue